import { Component, OnInit } from '@angular/core';

var posicaoFlexa = 1;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  logoMovimento() {
    setInterval(function () {
      switch (posicaoFlexa) {
        case 1:
          (<HTMLImageElement>document.getElementById("logo1")).src = "./assets/images/logo1.png";
          setTimeout(() => {
            posicaoFlexa = 2;
        }, 500);
          break;
        case 2:
          (<HTMLImageElement>document.getElementById("logo1")).src = "./assets/images/logo2.png";
          setTimeout(() => {
            posicaoFlexa = 3;
        }, 500);
          break;
        case 3:
          (<HTMLImageElement>document.getElementById("logo1")).src = "./assets/images/logo3.png";
          setTimeout(() => {
            posicaoFlexa = 4;
        }, 500);
          break;
        case 4:
          (<HTMLImageElement>document.getElementById("logo1")).src = "./assets/images/logo4.png";
          setTimeout(() => {
            posicaoFlexa = 5;
        }, 500);
          break;
        case 5:
          (<HTMLImageElement>document.getElementById("logo1")).src = "./assets/images/logo1.png";
          posicaoFlexa = 1;
          break;
        default:
          posicaoFlexa = 1;
          break;
      }
    }, 1000);
  }

  constructor() { }

  ngOnInit() {
    this.logoMovimento();
  }
}
